// extracted by mini-css-extract-plugin
export default {"spinner-container":"VXNPfe","spinnerContainer":"VXNPfe","spinner":"Dn0ToJ"};